import type { ReactNode } from 'react';

/** Shows AI suggestion before accept — labels output as editable. */
export default function AiPreviewDialog(props: {
  title: string;
  children: ReactNode;
  onAccept: () => void;
  onCancel: () => void;
}): JSX.Element | null {
  return (
    <div className="world-ai-fill-dialog" role="dialog" aria-modal="true" aria-label={props.title}>
      <div className="world-ai-fill-dialog-card">
        <h3 className="world-ai-fill-title">{props.title}</h3>
        <p className="world-muted">Generated suggestion — editable before you accept.</p>
        {props.children}
        <div className="world-action-row">
          <button type="button" className="btn-ghost" onClick={props.onCancel}>Cancel</button>
          <button type="button" className="btn-primary" onClick={props.onAccept}>Accept suggestion</button>
        </div>
      </div>
    </div>
  );
}
